import React from 'react'
import { BANKING_BOTTOM_CONTENT, CLOUD_COURSE_PAGE_1, CLOUD_DETAILS_PAGE_1, CLOUD_HERO_PAGE_1 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { CLOUD_ACCORDIAN } from '../../../utils/courseConifg'

const CloudPage_1 = () => {
  return (
    <div className='outlet-render'>
     <CourseAsideHero  {...CLOUD_HERO_PAGE_1}/>
      <CoursesAside {...CLOUD_COURSE_PAGE_1}/>
      <CourseCard {...CLOUD_DETAILS_PAGE_1}/>
      <Accordian {...CLOUD_ACCORDIAN}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default CloudPage_1